import { useMutation, useQueryClient } from 'react-query';
import {
  deleteAdaptedFictionEditionComment,
  type DeleteAdaptedFictionEditionCommentResponse
} from '../../services/commentsAndLikeService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useDeleteAdaptedFictionEditionComment({
  adaptedFictionEditionId,
  commentId
}: {
  adaptedFictionEditionId: string;
  commentId: string;
}) {
  const queryClient = useQueryClient();
  return useMutation<DeleteAdaptedFictionEditionCommentResponse, Error>({
    mutationFn: () => deleteAdaptedFictionEditionComment({ adaptedFictionEditionId, commentId }),
    onSuccess: () => {
      queryClient.invalidateQueries(
        SCENE_QUERY_KEYS.adaptedFictionEditionComments(adaptedFictionEditionId)
      );
      queryClient.invalidateQueries(
        SCENE_QUERY_KEYS.adaptedFictionEditionReplies(adaptedFictionEditionId)
      );
    }
  });
}
